import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import './Preview.css';
import { useLocation } from 'react-router-dom';
import Questionnaire from './Questionnaire/Questionnaire/Questionnaire';
import { API_END_POINT } from '../../../../config';
import axios from 'axios';
import LanguageQuestion from './Language/LanguageQuestion';

const Preview = () => {
  const [selectedView, setSelectedView] = useState('Desktop View');
  const [tabHeaderFooterData, setTabHeaderFooterData] = useState({});
  const [parsedData, setParsedData] = useState({});
 const [surveyInfo, setSurveyInfo] = useState({
    surveyId: null,
    surveyCode: null,
  });
  const [translations, setTranslations] = useState(null);
   const [loading, setLoading] = useState(true);
  const handleViewSelect = (view) => {
    setSelectedView(view);
  };

  const location = useLocation();
  const fetchTranslations = async (surveyCode) => {
    try {
      const response = await axios.get(`${API_END_POINT.BASE_URL}/api/Survey/GetSurveyTranslationByCode/${surveyCode}`);
      //console.log("Translations response:", parsedData);
      setTranslations(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching translations:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const previewId = params.get('previewId');
    const savedData = sessionStorage.getItem(previewId);
        const { 
      data, 
      surveyId, 
      surveyCode, 
    
    } = JSON?.parse(savedData);


    if (data) {
      const parsedData = data;
      setSurveyInfo({
        surveyId: surveyId,
        surveyCode: surveyCode,
        
      });
      //console.log(parsedData);
      setTabHeaderFooterData(parsedData);
      setParsedData(parsedData);
       fetchTranslations(surveyCode);
      const urlWithoutData = location.pathname;
      window.history.pushState({}, document.title, urlWithoutData);
    }
  }, [location.search]);


  return (
    <>
      <div className="preview-container">
        <div className="d-flex justify-content-between align-items-center">
          <div className={`preview-label  ${selectedView === 'Mobile View' ? 'mobile-label' : ''}`}>
            Survey Preview ({selectedView})
          </div>
          <Dropdown drop="down">
            <Dropdown.Toggle id="dropdown-basic">{selectedView}</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleViewSelect('Desktop View')}>
                Desktop View
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleViewSelect('Mobile View')}>
                Mobile View
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      
      <div className={selectedView === 'Mobile View' ? 'centeredAligned' : ''}>
        <div className={selectedView === 'Mobile View' ? 'mobile-content' : 'preview-content'}>
          <div className="content-wrapper">
             {!loading && Object.keys(parsedData).length > 0 && (
              // Check if we should show language selection or go straight to questionnaire
              parsedData?.translations?.languages?.length > 1 ? (
                <LanguageQuestion
                  pages={parsedData}
                  surveyCode={surveyInfo.surveyCode}
                  surveyId={surveyInfo.surveyId}
                  selectedView={selectedView}
                  translations={translations}
                />
              ) : (
                <Questionnaire
                  pages={parsedData}
                  surveyCode={surveyInfo.surveyCode}
                  surveyId={surveyInfo.surveyId}
                  selectedView={selectedView}
                  hasTranslations={translations?.languages?.length > 0}
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Preview;



